var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.997,
    height: 26.997,
    viewBox: "0 0 26.997 26.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#efebf6;opacity:.715}.cls-2{opacity:.966}.cls-3,.cls-6{fill:none}.cls-3{stroke:#7644c9;stroke-width:2.5px}.cls-4{fill:#7644c9}.cls-5{stroke:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_nuevo",
    transform: "translate(-43.5 -147.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1772",
    d: "M13 0A13 13 0 1 1 0 13 13 13 0 0 1 13 0z",
    className: "cls-1",
    "data-name": "Trazado 1772",
    transform: "translate(44 148)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_731",
    className: "cls-2",
    "data-name": "Grupo 731",
    transform: "translate(46 150.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_136",
    className: "cls-3",
    "data-name": "Elipse 136"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.999,
    cy: 10.999,
    r: 10.999,
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.999,
    cy: 10.999,
    r: 12.249,
    className: "cls-6"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1798",
    d: "M9.765 17.29L6.95 14.476a1.129 1.129 0 0 1 0-1.6 1.129 1.129 0 0 1 1.594 0l1.956 1.948a.252.252 0 0 0 .355 0l6.472-6.472a1.127 1.127 0 0 1 1.6 0 1.13 1.13 0 0 1 0 1.593l-7.339 7.337a1.286 1.286 0 0 1-1.823.008z",
    className: "cls-4",
    "data-name": "Trazado 1798",
    transform: "translate(44.139 148.346)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheck);
export default __webpack_public_path__ + "static/media/ic-check.b14f321bc2661565eea870cbf237b8c2.svg";
export { ForwardRef as ReactComponent };